/* Ver el hub como lo ve otra persona.
 *
 * PARA QUÉ. Dar un permiso y no poder comprobar qué desbloqueó es adivinar.
 * Hoy la única forma de validar un acceso es pedirle a la persona que entre y
 * mande una captura, y eso tarda un día — así que en la práctica no se hace y
 * los permisos quedan sin verificar.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * LO QUE ESTO ES, Y LO QUE NO ES. Hay que tenerlo claro o se usa mal.
 *
 * ES una vista previa de lo que el hub DIBUJA para esa persona: qué baldosas
 * aparecen en el menú y cuáles no.
 *
 * NO ES una prueba de a qué puede LLEGAR. Los permisos del hub deciden qué se
 * dibuja; quien escribe una URL a mano se saltea el menú entero. Lo que de
 * verdad restringe es Supabase, del lado del servidor. Si esta pantalla
 * dijera "no ve Permisos" y alguien entendiera "no puede entrar a Permisos",
 * estaríamos usando una previsualización de menú como si fuera una auditoría
 * de seguridad — y ese error es peor que no tener la herramienta.
 *
 * NO CAMBIA LA SESIÓN. Todo lo que se toque mientras tanto se ejecuta con la
 * cuenta propia, no con la de la otra persona. Por eso la franja de aviso es
 * fija y no se puede cerrar: quien la olvide puede guardar algo creyendo que
 * lo guarda "como" otro.
 * ─────────────────────────────────────────────────────────────────────────
 *
 * QUIÉN PUEDE. Una sola cuenta, la del dueño del sistema. Se verifica acá
 * —o sea en el navegador— y eso alcanza JUSTAMENTE porque esto no da acceso a
 * nada: pinta menos baldosas de las que la persona ya tenía. Alguien que
 * trucara esto se estaría escondiendo cosas a sí mismo.
 */

/* Se lee de una variable de entorno con este valor por defecto, para no
 * clavar un mail en el código el día que el sistema cambie de manos. */
export const DUENO = (
  process.env.REACT_APP_MAIL_DUENO || "ignacio.antu@gmail.com"
)
  .trim()
  .toLowerCase();

export function puedeVerComo(mail) {
  return !!mail && String(mail).trim().toLowerCase() === DUENO;
}

/* La clave del navegador. La vista previa SOBREVIVE a recargar la página a
 * propósito: validar un acceso implica abrir pantallas, y si cada navegación
 * la cancelara habría que volver a elegir a la persona todo el tiempo.
 *
 * `sessionStorage` y no `localStorage`: al cerrar la pestaña se termina. Una
 * vista previa que sigue abierta mañana a la mañana es alguien mirando un hub
 * recortado sin acordarse de por qué. */
const CLAVE = "hub_ver_como";

export function leerVistaPrevia() {
  try {
    const v = sessionStorage.getItem(CLAVE);
    return v ? JSON.parse(v) : null;
  } catch (e) {
    return null;
  }
}

export function guardarVistaPrevia(persona) {
  try {
    if (persona) sessionStorage.setItem(CLAVE, JSON.stringify(persona));
    else sessionStorage.removeItem(CLAVE);
  } catch (e) {
    /* Sin sessionStorage la vista previa dura lo que dura la pantalla. No es
     * motivo para romper nada: es una herramienta de diagnóstico. */
  }
}
